import { render } from "./Tchatbot.vue?vue&type=template&id=1929b8b6"
import script from "./Tchatbot.vue?vue&type=script&lang=js"
export * from "./Tchatbot.vue?vue&type=script&lang=js"

import "./Tchatbot.vue?vue&type=style&index=0&id=1929b8b6&lang=css"

import exportComponent from "/Users/davidmarchesson2/Sites/app.idtonic.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__